<template>
  <section class="products" id="products">
    <h2>Choose The <span>Perfect</span> Gift</h2>
    <p class="highlight"></p>
    <div class="container">
      <div class="product__container" v-if="newArrivals">
        <product-card
          v-for="(product, index) in newArrivals"
          :key="index"
          :productId="product._id"
          :productName="product.name"
          :brand="product.brand"
          :price="product.price"
          :currency="product.currency"
          :ratings="product.rating"
          :image_url="product.images[0]"
          :in_stock="product.in_stock"
          @click="handleProductClick(product)"
          v-motion
          :initial="{ opacity: 0, y: 40 }"
          :visibleOnce="{
            opacity: 1,
            y: 0,
            transition: {
              delay: 100 + 150 * index,
            },
          }"
        />
      </div>
      <product-preloader type="inline" v-else>
        Loading products...
      </product-preloader>
    </div>
  </section>
</template>

<script>
import ProductCard from "@/components/home_components/cards/ProductCard.vue";
import ProductPreloader from "@/components/preloaders/ProductPreloader.vue";
export default {
  name: "NewArrivals",
  components: {
    ProductCard,
    ProductPreloader,
  },
  data() {
    return {
      newArrivals: [], // Initialize inputText with the prop value
    };
  },
  created() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      fetch("/data/products.json")
        .then((response) => response.json())
        .then((data) => {
          this.newArrivals = data.results.map((product) => {
            product.images[0] = product.images[0].replace("http", "https");

            return product;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleProductClick(index) {
      this.$emit("product-clicked", index);
    },
  },
};
</script>

<style>
.products {
  background-color: #fff;
  padding: 0;
  padding-bottom: 24px;
}

.products h2 {
  font-family: "Baskervville", serif;
  color: var(--bistre);
  font-size: 32px;
  margin-top: 32px;
}

.products h2 span {
  font-family: "Baskervville", serif;
  color: var(--lion);
}
</style>
